var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#expand_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "m15.5 3 2.3 2.3-2.89 2.87 1.42 1.42L19.2 6.7 21.5 9V3zm-12 6 2.3-2.3 2.87 2.89 1.42-1.42L7.2 5.3 9.5 3h-6zm6 12-2.3-2.3 2.89-2.87-1.42-1.42L5.8 17.3 3.5 15v6zm12-6-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87-2.3 2.3h6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "expand_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M.5 0h24v24H.5z"
  })))));
};
export default SvgExpand;